import { useLocation } from 'react-router'
import { ClassificationLoadingSkeleton } from '~/pages/document-classification/@x/document-page'
import { DataExtractionLoadingSkeleton } from '~/pages/document-data-extraction/@x/document-page'
import { PatientMatchingLoadingSkeleton } from '~/pages/document-patient-matching/@x/document-page'
import { DocumentReviewLayoutLoadingSkeleton } from '~/widgets/document-review-layout'

export function LoadingSkeleton() {
  const location = useLocation()

  switch (location.pathname.split('/').at(-1)) {
    case 'classification':
      return <DocumentReviewLayoutLoadingSkeleton loader={<ClassificationLoadingSkeleton />} />
    case 'data-extraction':
      return <DocumentReviewLayoutLoadingSkeleton loader={<DataExtractionLoadingSkeleton />} />
    case 'matching':
      return <PatientMatchingLoadingSkeleton />
    default:
      return null
  }
}
